<unity-dropdown-control
  [displayName]="$displayName()"
  [description]="$description()"
  [values]="$availableAgencies()"
  [valuePrimitive]="true"
  [control]="$control()"
  [defaultItem]="$defaultItem()"
  [showHint]="$showHint()"
  (selectionChangeEvent)="onSelectionChange($event)" />
